import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/api";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function ProfilTab() {
  const { t } = useLang();
  const [contentId, setContentId] = useState("");
  const [contentEn, setContentEn] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/profile").then((r) => {
      setContentId(r.data.content_id || "");
      setContentEn(r.data.content_en || "");
    }).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/profile", { content_id: contentId, content_en: contentEn });
      toast.success(t("common.saved"));
    } catch (err) { toast.error(fmtErr(err)); }
    setBusy(false);
  };

  return (
    <form onSubmit={save} className="max-w-3xl space-y-5" data-testid="profil-form">
      <div>
        <Label className="text-sm font-medium text-slate-700">Deskripsi Al Ibtisam (Bahasa Indonesia)</Label>
        <Textarea value={contentId} onChange={(e) => setContentId(e.target.value)} rows={10} className="mt-1.5" data-testid="profil-content-id" />
      </div>
      <div>
        <Label className="text-sm font-medium text-slate-700">Description (English)</Label>
        <Textarea value={contentEn} onChange={(e) => setContentEn(e.target.value)} rows={10} className="mt-1.5" data-testid="profil-content-en" />
      </div>
      <Button type="submit" disabled={busy} className="rounded-full bg-emerald-800 hover:bg-emerald-900" data-testid="profil-save-button">
        {busy ? t("common.loading") : t("common.save")}
      </Button>
    </form>
  );
}
